import { useEffect, useState } from 'react';
import styles from './CompleteQuestionnariePage.module.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { instance } from '~/utils/api/api';
import { Questionnaire } from '../Questionnaires/QuestionnairesBoard/QuestionnairesTable/QuestionnairesTable';
import { Spinner } from '~/ui';
import CompleteQuestionnariePageForm from './CompleteQuestionnariePageForm/CompleteQuestionnariePageForm';
import { useToastError } from '~/utils/useToastError';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const currentDate = dayjs();

const CompleteQuestionnariePage = () => {
  const { t } = useTranslation();
  const [questionnarie, setQuestionnarie] = useState<Questionnaire | null>(
    null
  );
  const [isQuestionnarieEnd, setIsQuestionnarieEnd] = useState(false);
  const [searchParams] = useSearchParams();
  const questionnarieId = searchParams.get('questionnarieId');
  const userId = searchParams.get('userId');
  const navigate = useNavigate();
  const toastError = useToastError();

  const getQuestionnarie = async () => {
    try {
      const { data } = await instance.get(
        `user-questionnaires/${questionnarieId}` +
          (userId ? `?user_id=${userId}` : '')
      );
      setQuestionnarie(data);
      const isEnd = currentDate.isAfter(data.removal_date, 'day');
      setIsQuestionnarieEnd(isEnd);
    } catch (error: any) {
      if (error.response.status === 403) {
        navigate('user-error', { replace: true });
      } else {
        toastError(error);
      }
    }
  };

  useEffect(() => {
    if (!questionnarie) {
      getQuestionnarie();
    }
  }, []);

  if (!questionnarie) {
    return (
      <div className={styles.loaderContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <main className={styles.completeQuestionnariePage}>
      {isQuestionnarieEnd ? (
        <div className={styles.endContainer}>
          {t('questionnaire_deadline_has_passed')}
        </div>
      ) : (
        <>
          <h2 className={styles.title}>iFCM</h2>
          <h3 className={styles.pageDescription}>{questionnarie.name}</h3>
          <CompleteQuestionnariePageForm
            questionnarie={questionnarie}
            userId={userId}
          />
        </>
      )}
    </main>
  );
};

export default CompleteQuestionnariePage;
